'use client';
import React from 'react';
import { Box, Button, Divider } from '@mui/material';

import { useT } from '@/hooks';

interface PreviousMarketsToggleProps {
  show: boolean;
  onToggle: () => void;
  sx?: any;
}

/**
 * A standardized toggle component for showing/hiding previous markets.
 * Displays a button centered between two dividers.
 */
export const PreviousMarketsToggle = ({ show, onToggle, sx = {} }: PreviousMarketsToggleProps) => {
  const { t } = useT();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mt: 4,
        mb: 2,
        ...sx,
      }}
    >
      <Divider sx={{ flex: 1 }} />
      <Button
        size="small"
        variant="outlined"
        onClick={onToggle}
        sx={{
          borderRadius: '999px',
          textTransform: 'none',
          fontSize: '0.75rem',
          px: 1.5,
          py: 0.5,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          borderColor: show ? 'primary.main' : 'divider',
          color: show ? 'primary.main' : 'text.primary',
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'rgba(var(--primary-rgb), 0.04)',
          },
        }}
      >
        {show
          ? `- ${t('sports.hideMarkets', { defaultValue: 'Hide Markets' })}`
          : `+ ${t('sports.previousMarkets', { defaultValue: 'Previous Markets' })}`}
      </Button>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
};
